import React, { useEffect, useState } from 'react';
import './CustomizeCake.css';
import Footer from '../Components/Footer';
import Navbar from './Components/Navbar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { submitEnquiry } from '../lib/enquiries';

function CustomizeCake() {
  const [formData, setFormData] = useState({
    customerName: '',
    email: '',
    phone: '',
    enquiryType: '',
    workshopType: '',
    groupSize: '',
    preferredDate: '',
    preferredTime: '',
    specialInstructions: '',
    pickupOrDelivery: 'pickup'
  });

  const [errors, setErrors] = useState({
    customerName: '',
    email: '',
    phone: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validateName = (name) => {
    if (!name.trim()) return 'Name is required';
    if (name.trim().length < 2) return 'Name must be at least 2 characters';
    if (!/^[a-zA-Z\s]+$/.test(name)) return 'Name should contain only letters and spaces';
    return '';
  };

  const validateEmail = (email) => {
    if (!email.trim()) return 'Email is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return 'Please enter a valid email address';
    return '';
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) return 'Phone number is required';
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''))) return 'Please enter a valid 10-digit phone number';
    return '';
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'customerName') setErrors(prev => ({ ...prev, customerName: validateName(value) }));
    else if (name === 'email') setErrors(prev => ({ ...prev, email: validateEmail(value) }));
    else if (name === 'phone') setErrors(prev => ({ ...prev, phone: validatePhone(value) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nameError = validateName(formData.customerName);
    const emailError = validateEmail(formData.email);
    const phoneError = validatePhone(formData.phone);
    setErrors({ customerName: nameError, email: emailError, phone: phoneError });

    if (nameError || emailError || phoneError) {
      toast.error('Please fix the errors in the form before submitting.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    // Actually send it before claiming success.
    const res = await submitEnquiry({
      type: 'personalised',
      name: formData.customerName,
      email: formData.email,
      phone: formData.phone,
      subject: formData.enquiryType ? `Personalised enquiry - ${formData.enquiryType}` : 'Personalised enquiry',
      message: formData.specialInstructions,
      details: {
        enquiryType: formData.enquiryType,
        workshopType: formData.workshopType,
        groupSize: formData.groupSize,
        preferredDate: formData.preferredDate,
        preferredTime: formData.preferredTime,
        pickupOrDelivery: formData.pickupOrDelivery,
      },
    });

    if (!res.success) {
      toast.error(res.message, { position: 'top-right', autoClose: 5000 });
      return;
    }

    toast.success('Enquiry sent successfully! Our team will contact you shortly.', {
      position: 'top-right',
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      style: { background: '#4caf50', color: '#fff', fontWeight: '500' },
    });
    setFormData({
      customerName: '',
      email: '',
      phone: '',
      enquiryType: '',
      workshopType: '',
      groupSize: '',
      preferredDate: '',
      preferredTime: '',
      specialInstructions: '',
      pickupOrDelivery: 'pickup',
    });
    setErrors({ customerName: '', email: '', phone: '' });
  };

  return (
    <div>
      <ToastContainer />
      <Navbar />
      <div className="customize-cake">
        <div className="customize-hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/weeklyritualbox1.jpeg)` }}>
          <div className="customize-hero-overlay" />
          <div className="customize-hero-content">
            <p className="customize-hero-label">PERSONALISED PRODUCTS</p>
            <h1 className="customize-hero-title">Made Just for You</h1>
            <p className="customize-hero-sub">Bespoke chai kits, custom gift boxes, workshop bookings, and bulk orders - tell us what you need and we'll make it happen.</p>
          </div>
        </div>

        <div className="cake-form-section">
          <div className="form-container">
            <form onSubmit={handleSubmit} className="cake-form">
              <div className="form-header">
                <h2>Personalised Enquiry Form</h2>
                <p>Custom orders, workshops, gifting & more - tell us what you&apos;re looking for.</p>
              </div>
              <div className="form-section">
                <h3>Contact Information</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="customerName">Full Name *</label>
                    <input
                      type="text"
                      id="customerName"
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your full name"
                      className={errors.customerName ? 'error' : ''}
                    />
                    {errors.customerName && <span className="error-message">{errors.customerName}</span>}
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your email"
                      className={errors.email ? 'error' : ''}
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your 10-digit phone number"
                    className={errors.phone ? 'error' : ''}
                  />
                  {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>
              </div>

              <div className="form-section">
                <h3>What are you interested in?</h3>
                <div className="form-group">
                  <label htmlFor="enquiryType">Enquiry Type *</label>
                  <select
                    id="enquiryType"
                    name="enquiryType"
                    value={formData.enquiryType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select type</option>
                    <option value="workshop">Chai & Connect - Wellness Workshop</option>
                    <option value="corporate">Corporate / Team experience</option>
                    <option value="gift">Gift boxes & hampers</option>
                    <option value="bulk">Bulk / wholesale order</option>
                    <option value="event">Event (Iftar, festival, celebration)</option>
                    <option value="other">General enquiry</option>
                  </select>
                </div>
                {formData.enquiryType === 'workshop' && (
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="workshopType">Workshop theme</label>
                      <select
                        id="workshopType"
                        name="workshopType"
                        value={formData.workshopType}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        <option value="karak">Viral Karak Chai</option>
                        <option value="wellness">Wellness (breathwork, mindful living)</option>
                        <option value="hormones">Hormones Honey</option>
                        <option value="gut">My Gut, My Problem</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="groupSize">Group size (approx.)</label>
                      <select
                        id="groupSize"
                        name="groupSize"
                        value={formData.groupSize}
                        onChange={handleInputChange}
                      >
                        <option value="">Select</option>
                        <option value="1-5">1-5 people</option>
                        <option value="6-10">6-10 people</option>
                        <option value="11-20">11-20 people</option>
                        <option value="20+">20+ (private/corporate)</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>

              <div className="form-section">
                <h3>When & how</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="preferredDate">Preferred Date</label>
                    <input
                      type="date"
                      id="preferredDate"
                      name="preferredDate"
                      value={formData.preferredDate}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="preferredTime">Preferred Time</label>
                    <select
                      id="preferredTime"
                      name="preferredTime"
                      value={formData.preferredTime}
                      onChange={handleInputChange}
                    >
                      <option value="">Select time</option>
                      <option value="12:00 PM - 02:00 PM">12:00 PM - 02:00 PM</option>
                      <option value="02:00 PM - 04:00 PM">02:00 PM - 04:00 PM</option>
                      <option value="04:00 PM - 06:00 PM">04:00 PM - 06:00 PM</option>
                      <option value="06:00 PM - 08:00 PM">06:00 PM - 08:00 PM</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Collection or delivery</label>
                  <div className="delivery-options">
                    <div
                      className={`delivery-option-card ${formData.pickupOrDelivery === 'pickup' ? 'selected' : ''}`}
                      onClick={() => handleInputChange({ target: { name: 'pickupOrDelivery', value: 'pickup' } })}
                    >
                      <input
                        type="radio"
                        name="pickupOrDelivery"
                        value="pickup"
                        checked={formData.pickupOrDelivery === 'pickup'}
                        onChange={handleInputChange}
                        className="hidden-radio"
                      />
                      <h4>Pickup</h4>
                      <p>Collect from us (Glasgow)</p>
                    </div>
                    <div
                      className={`delivery-option-card ${formData.pickupOrDelivery === 'delivery' ? 'selected' : ''}`}
                      onClick={() => handleInputChange({ target: { name: 'pickupOrDelivery', value: 'delivery' } })}
                    >
                      <input
                        type="radio"
                        name="pickupOrDelivery"
                        value="delivery"
                        checked={formData.pickupOrDelivery === 'delivery'}
                        onChange={handleInputChange}
                        className="hidden-radio"
                      />
                      <h4>Delivery</h4>
                      <p>We&apos;ll deliver to your address (UK)</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h3>Anything else?</h3>
                <div className="form-group">
                  <label htmlFor="specialInstructions">Additional details</label>
                  <textarea
                    id="specialInstructions"
                    name="specialInstructions"
                    value={formData.specialInstructions}
                    onChange={handleInputChange}
                    placeholder="Dietary requirements, venue, group type (e.g. hen party, team offsite), or any questions..."
                    rows="4"
                  />
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-btn">
                  Send Enquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CustomizeCake;
